export const DateUnits = Object.freeze({
    DAYS: 'days',
    WEEKS: 'weeks',
    MONTHS: 'months',
    YEARS: 'years',
});

export const Selectors = Object.freeze({
    FIRST: 'first',
    LAST: 'last',
    ANY: 'any',
});

export const Operators = Object.freeze({
    EQ: '=',
    LT: '<',
    GT: '>',
    LTE: '<=',
    GTE: '>=',
});

export const Sex = Object.freeze({
    MALE: '1',
    FEMALE: '2',
});
